import { useTheme } from '@flowcore-water/ui';

interface AudioPlayerProps {
  src: string;
  label?: string;
}

export function AudioPlayer({ src, label = 'Call Recording' }: AudioPlayerProps) {
  const { t } = useTheme();

  return (
    <div
      className="rounded-lg border p-3"
      style={{ background: t.cardBg, borderColor: t.borderSubtle }}
    >
      <div
        className="mb-2 text-xs font-mono uppercase tracking-wide"
        style={{ color: t.textMuted }}
      >
        {label}
      </div>
      <audio controls preload="none" className="w-full" style={{ height: 36 }}>
        <source src={src} />
        <a href={src} style={{ color: t.accent }} target="_blank" rel="noopener noreferrer">
          Download recording
        </a>
      </audio>
    </div>
  );
}
